import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./Header.css";
import logo from "../../Images/Logo.png";
// import logo from "../../Images/ak-logo.png";

// import { GiHamburgerMenu } from "react-icons/gi";
// import { AiOutlineClose } from "react-icons/ai";

const Header = () => {
  // const [show, SetShow] = useState(false);
  const [navbar, SetNavbar] = useState(false);

  const bgColor = () => {
    if (window.scrollY >= 80) {
      SetNavbar(true);
    } else {
      SetNavbar(false);
    }
  };
  window.addEventListener("scroll", bgColor);

  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  return (
    <div className={navbar ? "header bg-color" : "header"}>
      {/* <div className="container">
        <div className="header-content">
          <div className="logo">
            <Link to="/">
              <img src={logo} alt="logo" />
            </Link>
          </div>
          <div className="menu">
            <div
              className={show ? "mobile-menu-items" : "menu-items"}
              onClick={() => SetShow(false)}
            >
              <NavLink to="/" className="menu-link">
                Home
              </NavLink>
              <NavLink to="/about" className="menu-link">
                About us
              </NavLink>
              <NavLink to="/careers" className="menu-link">
                Careers
              </NavLink>
              <NavLink to="/contact" className="menu-link">
                Contact
              </NavLink>
            </div>
          </div>
          <div className="hamburger" onClick={() => SetShow(!show)}>
            {show ? <AiOutlineClose /> : <GiHamburgerMenu />}
          </div>
        </div>
      </div> */}

      {/* ==== Navbar Animated */}
      <div
        className="Navbar container"
        style={{ display: "flex", flexDirection: "row" }}
      >
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="logo" />
          </Link>
        </div>
        <div className={`nav-items ${isOpen && "open"}`}>
          <NavLink to="/" onClick={() => setIsOpen(false)}>
            Home
          </NavLink>
          <NavLink to="/about" onClick={() => setIsOpen(false)}>
            About Us
          </NavLink>
          <div
            className="dropdwn"
            onMouseEnter={() => setDropdownOpen(true)}
            onMouseLeave={() => setDropdownOpen(false)}
          >
            <NavLink to="/aiml">Services ▾</NavLink>
            {dropdownOpen && (
              <div className="dropdown-mnu">
                <NavLink
                  to="/aiml"
                  className="listItems"
                  onClick={() => {
                    setIsOpen(false);
                    setDropdownOpen(false);
                  }}
                >
                  AI-ML
                </NavLink>
                <NavLink
                  to="/cloudComputing"
                  className="listItems"
                  onClick={() => {
                    setIsOpen(false);
                    setDropdownOpen(false);
                  }}
                >
                  Cloud Computing
                </NavLink>
                <NavLink
                  to="/dataEngineering"
                  className="listItems"
                  onClick={() => {
                    setIsOpen(false);
                    setDropdownOpen(false);
                  }}
                >
                  Data Engineering
                </NavLink>
                <NavLink
                  to="/teamAugmentation"
                  className="listItems"
                  onClick={() => {
                    setIsOpen(false);
                    setDropdownOpen(false);
                  }}
                >
                  Team Augmentation
                </NavLink>
                <NavLink
                  to="/softwareandApplicationDevelopment"
                  className="listItems"
                  onClick={() => {
                    setIsOpen(false);
                    setDropdownOpen(false);
                  }}
                >
                  Software Development
                </NavLink>
                <NavLink
                  to="/digitalTransformation"
                  className="listItems"
                  onClick={() => {
                    setIsOpen(false);
                    setDropdownOpen(false);
                  }}
                >
                  Digital Transformation
                </NavLink>
                <NavLink
                  to="/devOps"
                  className="listItems"
                  onClick={() => {
                    setIsOpen(false);
                    setDropdownOpen(false);
                  }}
                >
                  DevOps
                </NavLink>
              </div>
            )}
          </div>
          <NavLink
            to="/portfolio"
            onClick={() => {
              setIsOpen(false);
              setDropdownOpen(false);
            }}
          >
            Portfolio
          </NavLink>
          <NavLink
            to="/contact"
            onClick={() => {
              setIsOpen(false);
              setDropdownOpen(false);
            }}
          >
            Contact
          </NavLink>
        </div>
        <div
          className={`nav-toggle ${isOpen && "open"}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <div className="bar"></div>
        </div>
      </div>
    </div>
  );
};

export default Header;
